var VButtonSizes = /* @__PURE__ */ ((VButtonSizes2) => {
  VButtonSizes2["SMALL"] = "SMALL";
  VButtonSizes2["MEDIUM"] = "MEDIUM";
  VButtonSizes2["LARGE"] = "LARGE";
  return VButtonSizes2;
})(VButtonSizes || {});
var VButtonVariants = /* @__PURE__ */ ((VButtonVariants2) => {
  VButtonVariants2["PRIMARY"] = "primary";
  VButtonVariants2["SECONDARY"] = "secondary";
  VButtonVariants2["ACCENT"] = "accent";
  VButtonVariants2["PLAIN"] = "plain";
  return VButtonVariants2;
})(VButtonVariants || {});
var EButtonStates = /* @__PURE__ */ ((EButtonStates2) => {
  EButtonStates2["DEFAULT"] = "default";
  EButtonStates2["DISABLED"] = "disabled";
  EButtonStates2["LOADING"] = "loading";
  return EButtonStates2;
})(EButtonStates || {});
export { VButtonSizes, VButtonVariants, EButtonStates };
export var EButtonElements = /* @__PURE__ */ ((EButtonElements2) => {
  EButtonElements2["ROOT"] = "root";
  return EButtonElements2;
})(EButtonElements || {});
